import { Component, OnInit } from '@angular/core';
import { NotificationService, Notification } from '../../core/notification.service';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-toast',
  template: `
    <div class="fixed bottom-4 right-4 max-w-sm space-y-2 z-50">
      <div *ngFor="let n of notifications" class="p-3 rounded shadow flex items-start gap-3"
           [ngClass]="{ 'bg-success text-white': n.type==='success', 'bg-danger text-white': n.type==='error', 'bg-blue-50 text-blue-900 border border-blue-200': n.type==='info', 'bg-amber-50 text-amber-900 border border-amber-200': n.type==='warning' }">
        <div class="flex-1">
          <div class="text-sm font-medium">
            <span *ngIf="n.type === 'success'">✅ Sucesso</span>
            <span *ngIf="n.type === 'error'">❌ Erro</span>
            <span *ngIf="n.type === 'info'">ℹ️ Informação</span>
            <span *ngIf="n.type === 'warning'">⚠️ Aviso</span>
          </div>
          <div class="text-sm">{{ n.message }}</div>
        </div>
        <div>
          <button (click)="close(n.id)" class="text-xs opacity-80">✕</button>
        </div>
      </div>
    </div>
  `
})
export class ToastComponent implements OnInit {
  notifications: Notification[] = [];

  constructor(private svc: NotificationService) {}

  ngOnInit(): void {
    this.svc.notifications$.subscribe(ns => this.notifications = ns);
  }

  close(id: string) { this.svc.remove(id); }
}

